import React from "react";

const MyInput = ({ inputType, placeholderText, value, func , min  }) => {
  return (
    <input
      type={inputType}
      placeholder={placeholderText}
      value={value}
      onChange={(e) => {
        func(e.target.value);
      }}
      min={min && min}
    />
  );
};

export default MyInput;
